import React from "react";

const TransactionDetails = ({ transactionDetails, startCaseCreation }) => (
  <div>
    <div className="row dnds-trans-details">
      {transactionDetails.issuerCode && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Issuer: </strong> <span>{transactionDetails.issuer} </span>
          </div>
        </div>
      )}
      {transactionDetails.merchant && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Merchant: </strong>{" "}
            <span>{transactionDetails.merchant}</span>
          </div>
        </div>
      )}
      {transactionDetails.nrid && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>NRID: </strong> <span>{transactionDetails.nrid}</span>
          </div>
        </div>
      )}
      {transactionDetails.transactionDate && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Transaction Date: </strong>{" "}
            <span>{transactionDetails.transactionDate}</span>
          </div>
        </div>
      )}
      {transactionDetails.transactionType && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Transaction Type: </strong>{" "}
            <span>{transactionDetails.transactionType}</span>
          </div>
        </div>
      )}
      {transactionDetails.transactionAmount && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Transaction Amount: </strong>{" "}
            <span>{transactionDetails.transactionAmount}</span>
          </div>
        </div>
      )}
      <div className="col-sm-4 dnds-detail">
        {transactionDetails.settlementAmount && (
          <div>
            <strong>Settlement Amount: </strong>{" "}
            <span>{transactionDetails.settlementAmount}</span>
          </div>
        )}
      </div>
      {transactionDetails.schemeAmount && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Scheme Amount: </strong>{" "}
            <span>{transactionDetails.schemeAmount}</span>
          </div>
        </div>
      )}
      {transactionDetails.pan && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>PAN: </strong> <span>{transactionDetails.pan}</span>
          </div>
        </div>
      )}
      {transactionDetails.terminalId && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Terminal Id: </strong>{" "}
            <span>{transactionDetails.terminalId}</span>
          </div>
        </div>
      )}
      {transactionDetails.stan && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>STAN: </strong> <span>{transactionDetails.stan}</span>
          </div>
        </div>
      )}
      {transactionDetails.retrievalReferenceNumber && (
        <div className="col-sm-4 dnds-detail">
          <div>
            <strong>Retrieval Reference Number: </strong>{" "}
            <span>{transactionDetails.retrievalReferenceNumber}</span>
          </div>
        </div>
      )}
    </div>

    <div className="row">
      <div className="col-xs-12 text-center">
        {transactionDetails.transactionErrors &&
        transactionDetails.transactionErrors.length ? (
          <div className="alert alert-danger text-left">
            <ul>
              {transactionDetails.transactionErrors.map((error, index) => (
                <li key={index}>{error}</li>
              ))}
            </ul>
          </div>
        ) : (
          ""
        )}

        {transactionDetails.dnCaseNumber && (
          <div className="alert alert-info">
            A case has already been created for this transaction.{" "}
            <strong>Case number: {transactionDetails.dnCaseNumber}</strong>
          </div>
        )}

        {!transactionDetails.dnCaseNumber &&
        (!transactionDetails.transactionErrors ||
          (transactionDetails.transactionErrors &&
            !transactionDetails.transactionErrors.length)) ? (
          <button className="btn btn-primary" onClick={startCaseCreation}>
            Create Case
          </button>
        ) : (
          ""
        )}
      </div>
    </div>
  </div>
);

export default TransactionDetails;



// WEBPACK FOOTER //
// ./src/components/discover/newCase/transactionDetail/TransactionDetails.js